export enum Roles {
  SuperAdmin = 1,
  Administrador = 2,
  Notificador = 3,
}
